
var _ = require('underscore'),
    TextBox = require('./textAreaModels/box'),
    DerivedWordModel = require('./textAreaModels/derivedWord');


/**
 * These are the 'derived' word model from the create from pages' positional text data models.
 * A mixture of 'original' and 'derived' words
 * Avoiding a Backbone Collection now due to overhead, wanting to rid Backbone, and existing logic implemented for an array.
 * Really a 'wrapper class' for the array.
 * 1) Combines words with dashes
 * 2) Removes words that are just white space or are empty.
 */


function DocumentWordModels( aPagesWithPositionalData ) {

    this.words = [];

    if ( aPagesWithPositionalData && aPagesWithPositionalData.length > 0 ) {
        this.setWords( aPagesWithPositionalData );
    }

}


_.extend( DocumentWordModels.prototype, {


    setWords: function( aPagesWithPositionalData ) {

        var allWords = this._getAllWordModels( aPagesWithPositionalData );

        // Filter out any words that are empty or only contain white-space
        // https://stackoverflow.com/questions/17524290/how-to-check-for-string-having-only-spaces-in-javascript
        // We don't want to include or search for words that are whitespace or empty
        // This is an outlier but may as well nip in the bud with this new design with a one-liner,
        // Just in case
        allWords = _.reject( allWords, function(word) {
            return /^\s*$/.test( word.get('wd') );
        } );

        // Create combined words from dashes
        this.words = this.squashDashes( allWords );

        // Set the document level ids of all the word models after they are 'squashed'
        _.each( this.words, function(word, i) {
            word.set('id', i);
        });

        // Post-process 'derived' words -- again could be more efficient with squashDashes/combo
        var combinedWords = this.getDerivedWords();

        _.each( combinedWords, function( word ) {

            word.postProcessCombinedWord();

        });

        // inspection:
        // viewer.activeDocument.derivedWordModels.words.filter( w => w.get('isDerived') ).map( w => w.get('subWordReferences').map( sw => JSON.stringify(sw) ))

    },

    getWords: function() {

        return this.words;

    },

    getDerivedWords: function() {

        return _.filter( this.words, function( word ) {
           return word.get('isDerived');
        });

    },

    // ('Non-derived')
    _getAllWordModels: function( aPagesWithPositionalData ) {

        return _.reduce( aPagesWithPositionalData, function( allWordModels, page ) {
            return allWordModels.concat( page.getPositionalTextDataModel().getWords().models );
        }, [] );

    },

    // Adapted from dash-test
    squashDashes: function( aWordModels ) {

        // First create array from the original 'combining' words that start with a dash
        // with the those before them.
        var aDashStart = [];

        for ( var i=0; i< aWordModels.length ; i++ ) {

            var currentWord = aWordModels[i];
            var startsWithDash = currentWord.get('wd')[0] === '-'; // Can put on the word model

            if ( startsWithDash ) {

                var lastDerivedWdIndex = aDashStart.length-1;
                var prevDerivedWd = aDashStart[lastDerivedWdIndex];

                if ( prevDerivedWd ) {

                    aDashStart[lastDerivedWdIndex] =
                        new DerivedWordModel( prevDerivedWd, currentWord, 1 );

                } else {

                    aDashStart.push( currentWord );
                }

            }

            else {
                aDashStart.push( currentWord );
            }

        }

        // Take the first array and loop through backwards, combining words that end with a dash
        // and those before them.
        var aEndsWith = [];

        for ( var i= aDashStart.length - 1; i >-1 ; i-- ) {

            var currentWord = aDashStart[i];
            var currentWordTxt = currentWord.get('wd');
            var endsWithDash = currentWordTxt[currentWordTxt.length - 1] === '-'; // can be fn of word

            if ( endsWithDash ) {

                var lastDerivedWdIndex = aEndsWith.length-1;
                var prevDerivedWd = aEndsWith[lastDerivedWdIndex];

                if ( prevDerivedWd ) {

                    aEndsWith[lastDerivedWdIndex] =
                        new DerivedWordModel( prevDerivedWd, currentWord, 0 );


                } else {
                    aEndsWith.push( currentWord );
                }

            } else {

                aEndsWith.push( currentWord );
            }

        }


        return aEndsWith.reverse();

    }


    // troubleshooting snippet:
    // viewer.request('activeDocumentTextModel').getDerivedWordModels().filter( w => w.get('isDerived') ).map( w => JSON.stringify( w.get('subwordIds' ) ) )
    // viewer.request('activeDocumentTextModel').getDerivedWordModels().filter( w => w.get('isDerived') ).map( w => JSON.stringify(w.get('subwordPageLevelKeys' )) )

    // eg -- debug words spit on different lines
    // viewer.request('activeDocumentTextModel').getDerivedWordModels().filter( m => m.get('isMultiLine' ) ).map( m => ({ wd: m.get('wd'), page: m.get('pageNumber') }) )

});




module.exports = DocumentWordModels;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/positionalTextModels/DerivedPositionalWords.js
 ** module id = 407
 ** module chunks = 0
 **/